module.exports = __webpack_public_path__ + "img/341.b4ff541.png";